module.exports = __webpack_public_path__ + "static/img/p3.5878ec2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/p3.png
// module id = daEU
// module chunks = 0